export var PipelineError;
(function (PipelineError) {
    let Type;
    (function (Type) {
        Type["InternalError"] = "InternalError";
        Type["InvalidExprCall"] = "InvalidExprCall";
    })(Type = PipelineError.Type || (PipelineError.Type = {}));
    class InternalError extends Error {
        constructor(message) {
            super(message);
            this.name = "InternalError";
            Object.setPrototypeOf(this, InternalError.prototype);
        }
    }
    PipelineError.InternalError = InternalError;
    class InvalidExprCall extends Error {
        constructor(callName, causes) {
            super(getExprCallErrorMessage(callName, causes));
            this.callName = callName;
            this.causes = causes;
            this.name = "InvalidExprCall";
            Object.setPrototypeOf(this, InvalidExprCall.prototype);
        }
    }
    PipelineError.InvalidExprCall = InvalidExprCall;
    function getExprCallErrorMessage(callName, errors) {
        const base = `Invalid call to ${callName}`;
        if (errors && errors.length) {
            const errorMessage = errors[0].message;
            if (errorMessage) {
                return base + ': ' + errorMessage;
            }
        }
        return base;
    }
})(PipelineError || (PipelineError = {}));
